module.exports = __webpack_public_path__ + "static/media/aftex-fix.3d482095.png";